import React from "react";
export function QuoteBreakUp(props) {
  const termsAndConditions = [
    `Bookings should be made minimum one week prior to the date of planned move out.`,
    `An advance payment of Rs.1500 should be made as “Token Amount” for booking confirmation.`,
    `Customers are requested to provide proper authorized proofs for their ‘move out’ and ‘move in’ to avoid further inconvenience.`,
  ];

  const { quote, tax } = props;


  const getDiscountAmt = (quote) => {
    if (quote === null) {
      return 0;
    }
    if (
      quote.sales_summary["discount"] !== undefined ||
      quote.sales_summary["discount"] !== null
    ) {
      return parseFloat(quote.sales_summary["discount"]["amount"]);
    }
    return 0;
  };
  const GST = quote.sales_summary["gst_charge"];
  const total = quote.sales_summary["total"];
  const discount = getDiscountAmt(quote);
  const chargesList = quote.items;
  const getDiscountLabel = (discount, quote) => {
    return (
      "Discount " +
      (quote.sales_summary["discount"]["type"] === "percentage"
        ? `[${quote.sales_summary["discount"]["value"]}%]`
        : `[₹${discount}]`)
    );
  };

  const JSX = (
    <>
      <div className="quote-charges-container">
        <div className="row">
          <div className="col-sm-12 col-md-6 charges-order-level-1">
            <div className="terms-label mb-3">Terms and Conditions</div>
            <ul className="p-0">
              {termsAndConditions.map((terms) => {
                return (
                  <li className="terms-list">
                    <div className="rectangle-icon"></div>
                    <span className="terms-text">{terms}</span>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="col-sm-12 col-md-6 charges-order-level-2">
            {chargesList.map((charge, index) => {
              if (charge.category === "gst_charge") {
                return <></>;
              }
              if (charge.sales_info.amount > 0 || charge.sales_info.description.trim() !== "") {
                return (
                  <div className="w-100 d-flex justify-content-between mb-2 border-bottom">
                    <div className="charge-label ">
                      <div className="charge-text text-capitalize">{charge.display_name}</div>
                      <div className="charge-description">{charge.sales_info.description} </div>
                    </div>
                    <span className="charge-value">
                      ₹ {charge.sales_info.amount}
                    </span>
                  </div>
                );
              }
              return <></>;
            })}

              <div className="w-100 d-flex justify-content-between mb-2">
                <div className="charge-label">
                  Sub Total
                </div>
                <span className="charge-value">₹ {parseFloat(quote.sales_summary.sub_total).toFixed(2)}</span>
              </div>
            {discount > 0 && (
              <div className="w-100 d-flex justify-content-between mb-2">
                <div className="charge-label">
                  {getDiscountLabel(discount, quote)}
                </div>
                <span className="charge-value">-₹ {discount}</span>
              </div>
            )}
            {GST >= 0 && (
              <div className="w-100 d-flex justify-content-between mb-2">
                <div className="charge-label">
                  {tax["tax_name"] !== null
                    ? `${tax["tax_name"]} [${tax["tax_value"]}%]`
                    : `GST`}
                </div>
                <span className="charge-value">₹ {GST}</span>
              </div>
            )}
            <div className="w-100 d-flex justify-content-between mb-2">
              <div>
                <div className="dashboard-bold">
                  <b> Net total </b>
                </div>
                <div>(incl. of GST)</div>
              </div>
              <span className="dashboard-bold">
                <b>₹ {total} </b>
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
  return JSX;
}
